<div class="width-80">
  <div class="array-header">
    <span class="left-span">
      <h3 >Factures à régler ({{invoices.length}})</h3>
    </span>
    <span class="right-span">
      <button matButton="filled" class="right-button" routerLink="/factures">
        Afficher tout
      </button>
    </span>
  </div>
  <div class="white-rounded-container array-container">
    <app-prime-ng-array-d4 arrayName="factureAccueil" nullArrayDisplayText="Aucune commande" columnResizeMode="fit"
      [displayPaginator]="false" [columnsDefinition]="invoicesColumnsDefinition" [objectList]="invoices"
      [heightMode]="'full'" [allowArrayCustomisation]="false" [loading]="loading">
    </app-prime-ng-array-d4>
  </div>
</div>
<div class="width-80 ">
  <div class="array-header">
    <span class="left-span">
      <h3>Commandes non clôturées ({{orders.length}})</h3>
    </span>
    <span class="right-span">
      <button matButton="filled" class="right-button" routerLink="/commandes">
        Afficher tout
      </button>
    </span>
  </div>
  <div class="white-rounded-container array-container">
    <app-prime-ng-array-d4 arrayName="commandesAccueil" nullArrayDisplayText="Aucune commande" columnResizeMode="fit"
      [displayPaginator]="false" [allowArrayCustomisation]="false" [columnsDefinition]="ordersColumnsDefinition"
      [objectList]="orders" [heightMode]="'full'" [loading]="loading">
    </app-prime-ng-array-d4>
  </div>
</div>